import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './VirtualPage.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faComment, faDownload, faChevronLeft, faUpload, faEye, faStar } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartSolid } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import axios from "axios";
import APP_BASE_URL from "../../components/Api/globalApi";
import { io } from "socket.io-client";
import { Navbar, Nav, Container, Row, Col, Tabs, Tab, Button, Modal, Form } from 'react-bootstrap';
import { useForm } from "react-hook-form";


function VirtualPage() {
	const { register, handleSubmit, watch, reset, setValue, formState } = useForm();
	const [wallDecoration, setWallDecorations] = useState([[]]);
	const [Points, setPoints] = useState(null);
	const [uploadModel, setUploadModel] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [image, setImage] = useState("");
	const [adsId, setAdsId] = useState();
	const [liked, setLiked] = useState(false);
	const [likeCount, setLikeCount] = useState("");
	const [comment, setComment] = useState("");
	const [phoneNumber, setPhoneNumber] = useState(null);
	const [activeCommentPostId, setActiveCommentPostId] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [isLiking, setIsLiking] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [showFullLocation, setShowFullLocation] = useState(false);



	const fetchData = async (page = 1, isLoadMore = false) => {
		try {
			setIsLoading(true);
			const response = await axios.get(
				`${APP_BASE_URL}/vitual_mall/ads/list`,
				{
					headers: {
						user_id: localStorage.getItem("user_id"),
						how: 'single'
					},
					params: {
						page: page,
						limit: 10 // You can adjust this based on your needs
					}
				}
			);

			if (isLoadMore) {
				// For infinite scroll/pagination: append new data
				setWallDecorations(prev => [...prev, ...(response.data.data || [])]);
			} else {
				// For initial load or refresh: replace data
				setWallDecorations(response.data.data || []);
			}

			setPoints(response.data.user_temp_point);

			// If your API returns total pages or total count
			if (response.data.totalPages) {
				setTotalPages(response.data.totalPages);
			}
			if (response.data.totalCount) {
				setHasMore(response.data.data.length > 0 &&
					response.data.data.length < response.data.totalCount);
			}

			setCurrentPage(page);
		} catch (error) {
			console.error("Advertisement error:", error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchData(1); // Load first page initially
	}, []);

	useEffect(() => {
		// This will run whenever currentPage changes
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, [currentPage]);

	const handleDownload = (url) => {
		fetch(url, {
			mode: "cors",
		})
			.then((response) => response.blob())
			.then((blob) => {
				const blobUrl = window.URL.createObjectURL(blob);
				const a = document.createElement("a");
				a.href = blobUrl;
				const fileName = url.split("/").pop();
				a.download = fileName;
				document.body.appendChild(a);
				a.click();
				a.remove();
				window.URL.revokeObjectURL(blobUrl);
			})
			.catch((err) => {
				console.error("Download failed:", err);
			});
	};

	const onSubmit = async (data) => {
		console.log("ad Submitted", data);

		try {

			const formData = new FormData();
			formData.append("image", data.image[0]);
			formData.append("views", data.views);
			formData.append("phone_number", data.phone_number);
			formData.append("a_id", adsId);
			console.log(data, data.image[0], 'formdata')

			const response = await axios.post(
				`${APP_BASE_URL}/vitual_mall/upload`,
				formData,
				{
					headers: { user_id: localStorage.getItem("user_id") },
				}
			);
			if (response?.data?.result) {
				setShowModal(false);
				alert("advertisement added successfully")
				window.location.reload();
			} else {
				alert("error when adding advertisement")
			}

			console.log(response.data.result, 'response')
		} catch (error) {
			console.error("Error when adding advertisement", error);
		}
	};

	const handleCloseModal = () => {
		setUploadModel(false);
	};
	// useEffect(() => {
	//   return () => {
	//     if (socket.current) {
	//       socket.current.disconnect();
	//       console.log("Socket disconnected on unmount");
	//     }
	//   };
	// }, []);

	// const socket = useRef(null);
	// const baseurl = "https://api.springwayhub.com/";

	// const handleLike = (post) => {
	//   // If socket not connected, create a new connection
	//   if (!socket.current || !socket.current.connected) {
	//     socket.current = io(baseurl, {
	//       transports: ["websocket"],
	//       secure: true,
	//     });

	//     // Wait for connection before emitting
	//     socket.current.on("connect", () => {
	//       console.log("Socket connected:", socket.current.id);

	//       // Join the room (optional if needed)
	//       socket.current.emit("join_room", post.ads_id);

	//       // Now emit the like
	//       socket.current.emit("like_sent", {
	//         a_id: post.ads_id,
	//         user_id: localStorage.getItem("user_id"),
	//       });
	//     });

	//     socket.current.on("connect_error", (err) => {
	//       console.error("Socket connection error:", err);
	//     });

	//   } else {
	//     // Already connected, emit immediately
	//     socket.current.emit("like_sent", {
	//       a_id: post.ads_id,
	//       user_id: localStorage.getItem("user_id"),
	//     });
	//   }

	//   // Update UI state
	//   setLiked(true);
	//   setLikeCount(prev => (prev ? prev + 1 : 1));
	// };


	function formatNumber(num) {
		if (num >= 1e9) return (num / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
		if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
		if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
		return num?.toString();
	}

	const handleLike = async (data) => {
		try {
			const response = await axios.post(
				`${APP_BASE_URL}/vitual_mall/ads/like`,
				{
					user_id: localStorage.getItem("user_id"),
					a_id: data.ads_id
				}
			);

			if (response?.data?.result) {
				// Update the local state instead of reloading
				setWallDecorations(prev => prev.map(post => {
					if (post.ads_id === data.ads_id) {
						return {
							...post,
							like_status: !post.like_status, // Toggle like status
							ads_like: post.like_status ? post.ads_like - 1 : post.ads_like + 1, // Update count
							ads_total: post.ads_total - post.ads_single
						};
					}
					return post;
				}));
			} else {
				alert(response?.data?.message);
			}
		} catch (error) {
			alert("error while like");
		}
	}

	const handleComment = async (data) => {
		try {
			// if (localStorage.getItem("user_id")) {
			//   setShowPhoneNumber(true)
			// }
			const response = await axios.post(
				`${APP_BASE_URL}/vitual_mall/ads/comment`,
				{
					user_id: localStorage.getItem("user_id"),
					a_id: data.ads_id,
					comment: comment,
					phone_number: null
				}
			);
			if (response?.data?.result) {
				setLiked(response?.data?.result);
			} else {
				alert(response?.data?.message);
			}
		} catch (error) {
			alert("error while like");
		}
	}
	return (
		<div className="App">
			{/* Header */}
			<header className="border-bottom sticky-top bg-white">
				<div className="container">
					<div className="row justify-content-center align-items-center py-2">
						{/* <div className="col-4 text-left">
              <button className="btn p-0">
                <FontAwesomeIcon icon={faChevronLeft} size="lg" className="text-dark" />
              </button>
            </div> */}
						<div className="col-4 text-center">
							<p>{Points !== null ? <h5 className="mb-0 text-dark">User Points: {Points}</h5> : ''}</p>
						</div>
						<div className="col-4 text-end">
							{/* Empty space for balance */}
						</div>
					</div>
				</div>
			</header>

			{/* Main Content */}
			<main className="container mt-3">
				<div className="row justify-content-center">
					{/* Feed */}
					<div className="col-12 col-md-8 col-lg-6">
						{/* Posts */}{console.log(wallDecoration, "wallDecoration")}
						{wallDecoration?.map(post => (
							<div key={post.ads_id} className="mb-4">

								{/* Post Image */}
								<img src={post?.ads_image?.replace('macdon360.in', 'api.macdonitsolutions.com')} className="card-img-top" alt={post.ads_description} />

								<div className="d-flex justify-content-between align-items-center mb-1">
									<div className="d-flex align-items-center">
										<FontAwesomeIcon icon={faStar} className="me-1 text-warning" />
										<span className="text-muted">{post.ads_single} Points</span>
									</div>

									<div className="d-flex align-items-center">
										<FontAwesomeIcon icon={faStar} className="me-1 text-warning" />
										<span className="text-muted">{post.ads_total} Total Points</span>
									</div>
								</div>



								{/* Post Actions */}
								<div className="card-body p-3">
									<div className="d-flex mb-2">
										<button className="btn btn-sm p-0 me-3">
											<FontAwesomeIcon icon={post.like_status == true ? faHeartSolid : faHeartRegular} size="lg"
												style={{ color: post.like_status == true ? 'red' : 'black' }} onClick={() => handleLike(post)}
											/>
										</button>
										<button
											className="btn btn-sm p-0 me-3"
											onClick={() => {
												setActiveCommentPostId(post.ads_id === activeCommentPostId ? null : post.ads_id);
											}}
										>
											<FontAwesomeIcon icon={faComment} size="lg" />
										</button>

										<button className="btn btn-sm p-0 me-3" onClick={() => { handleDownload(post.ads_image) }}>
											<FontAwesomeIcon icon={faDownload} size="lg" />
										</button>


										<button className="btn btn-sm p-0 me-3" onClick={() => {
											setUploadModel(true)
											setAdsId(post.ads_id)
											setLikeCount(post.ads_like)
										}}>
											<FontAwesomeIcon icon={faUpload} size="lg" />
										</button>
										<div className="d-flex justify-content-end align-items-center mb-1">
											<FontAwesomeIcon icon={faEye} className="me-1 text-muted" />
											<span className="text-muted">{formatNumber(post.ads_views)} views</span>
										</div>
									</div>

									{/* Likes */}
									<div className="mb-2 d-flex justify-content-between">
										<strong>{post.ads_like} likes</strong>
										{post.ads_location && (
											<span className="text-muted">
												#
												{showFullLocation
													? post.ads_location
													: `${post.ads_location?.slice(0, 20)}${post.ads_location?.length > 20 ? '...' : ''}`}

												{post.ads_location?.length > 20 && (
													<span
														onClick={() => setShowFullLocation(!showFullLocation)}
														style={{ color: '#7f00ff', cursor: 'pointer', marginLeft: '5px', fontWeight: 'bold' }}
													>
														{showFullLocation ? 'See less' : 'See more'}
													</span>
												)}
											</span>
										)}
									</div>

									{/* Caption */}
									<div className="mb-2">
										{expanded
											? post.ads_description
											: `${post.ads_description?.slice(0, 20)}...`}
										{post.ads_description?.length > 20 && (
											<span
												onClick={() => setExpanded(!expanded)}
												style={{ color: '#7f00ff', cursor: 'pointer', marginLeft: '5px', fontWeight: 'bold' }}
											>
												{expanded ? 'See less' : 'See more'}
											</span>
										)}
									</div>


									{/* Add Comment */}
									{activeCommentPostId === post.ads_id && (
										<div className="input-group mt-2">
											{/* {localStorage.getItem("user_id") ? (
                        <> */}
											<input
												type="text"
												className="form-control border-0 bg-light"
												placeholder="Add a comment..."
												value={comment}
												onChange={(e) => setComment(e.target.value)}
											/>
											<button
												className="btn btn-link text-primary"
												onClick={() => {
													handleComment(post);
													setComment('');
												}}
											>
												Post
											</button>
											{/* </>
                      ) : (
                        <>
                          <input
                            type="tel"
                            className="form-control border-0 bg-light"
                            placeholder="Enter your phone number"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            maxLength={10}
                          />
                          <button
                            className="btn btn-link text-primary"
                            onClick={() => handleComment(post)}
                          >
                            Post
                          </button>
                        </> */}
											{/* )} */}
										</div>

									)}

								</div>
							</div>
						))}
					</div>
				</div>
				{/* Add this after your posts rendering */}
				<div className="d-flex justify-content-center mt-4 mb-4">
					<Button
						variant="outline-primary"
						disabled={currentPage === 1 || isLoading}
						onClick={() => fetchData(currentPage - 1)}
						className="me-2"
					>
						Previous
					</Button>

					<span className="mx-3 align-self-center">
						Page {currentPage} of {totalPages}
					</span>

					<Button
						variant="outline-primary"
						disabled={currentPage >= totalPages || isLoading || !hasMore}
						onClick={() => fetchData(currentPage + 1)}
					>
						Next
					</Button>
				</div>
			</main>

			{/* Remove the outer div and conditional - Modal handles its own visibility */}
			<Modal
				show={uploadModel}
				onHide={handleCloseModal}
				centered
				backdrop="static" // Prevents closing when clicking outside
			>
				<Modal.Header closeButton>
					<Modal.Title>Add Advertisement</Modal.Title> {/* Added title for clarity */}
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<Form.Group controlId="referral">
							<Form.Label>Add Advertisement</Form.Label>
							<Form.Control
								type="file"
								accept="image/*"
								{...register("image", {
									required: "Please select an image file",
									validate: {
										isImage: value =>
											value[0]?.type.startsWith("image/") ||
											"Only image files are allowed"
									},
								})}
								onChange={(e) => setImage(e.target.value)}
								isInvalid={!!formState.errors.image}
							/>
							<Form.Control.Feedback type="invalid">
								{formState.errors.image?.message}
							</Form.Control.Feedback>
						</Form.Group>

						<Form.Group controlId="title" className="mt-3">
							<Form.Label>Views Count</Form.Label>
							<Form.Control
								type="number"
								placeholder="Enter Views Count"
								{...register("views", {
									required: "views count is required",
								})}
								isInvalid={!!formState.errors.title}
							/>
							<Form.Control.Feedback type="invalid">
								{formState.errors.title?.message}
							</Form.Control.Feedback>
						</Form.Group>

						<Form.Group controlId="phone_number" className="mt-3">
							<Form.Label>Phone Number</Form.Label>
							<Form.Control
								type="tel"
								placeholder="Enter phone number"
								{...register("phone_number", {
									required: "Phone number is required",
									pattern: {
										value: /^[0-9]{10}$/,
										message: "Phone number must be 10 digits"
									}
								})}
								isInvalid={!!formState.errors.phone_number}
							/>
							<Form.Control.Feedback type="invalid">
								{formState.errors.phone_number?.message}
							</Form.Control.Feedback>
						</Form.Group>

						{/* Button with enhanced visibility */}
						<Button
							variant="primary"
							type="submit"
							className="mt-3 w-100"
							style={{
								padding: '10px',
								fontSize: '1.1rem',
								fontWeight: 'bold',
								backgroundColor: '#0d6efd', // Bootstrap primary color
								color: '#fff',              // white text
								border: 'none'
							}}
							disabled={formState.isSubmitting}
						>

							{formState.isSubmitting ? (
								<>
									<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									Uploading...
								</>
							) : 'Upload'}
						</Button>
					</Form>
				</Modal.Body>
			</Modal>
		</div>
	);
}

export default VirtualPage;